import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "./Dashboard";
import { Modal, Field, Th, Td } from "./Customers";
import { Plus } from "lucide-react";

export default function Warehouses() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/warehouses").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-12 max-w-[1400px]" data-testid="warehouses-page">
      <PageHeader
        title="Warehouses"
        subtitle="Stock-keeping locations."
        action={
          <button onClick={() => setOpen(true)} data-testid="add-warehouse-btn"
            className="inline-flex items-center gap-2 bg-[#0A0A0A] hover:bg-[#FF4F00] text-white px-4 py-2.5 text-sm font-medium rounded-sm">
            <Plus size={14} /> New warehouse
          </button>
        }
      />
      <div className="mt-8 border border-[#0A0A0A] bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-[#0A0A0A] text-white text-[11px] uppercase tracking-[0.15em]">
            <tr><Th>Code</Th><Th>Name</Th><Th>Location</Th></tr>
          </thead>
          <tbody>
            {rows.map((w, i) => (
              <tr key={w.id} data-testid={`warehouse-row-${i}`} className="border-b border-[#DEE2E6] hover:bg-[#F8F9FA]">
                <Td className="font-mono text-xs">{w.code}</Td>
                <Td><div className="font-medium">{w.name}</div></Td>
                <Td className="text-[#495057]">{w.location || "—"}</Td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={3} className="p-8 text-center text-[#495057]">No warehouses yet.</td></tr>}
          </tbody>
        </table>
      </div>
      {open && <WhForm onClose={() => setOpen(false)} onSaved={() => { setOpen(false); load(); }} />}
    </div>
  );
}

function WhForm({ onClose, onSaved }) {
  const [f, setF] = useState({ code: "", name: "", location: "" });
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setErr("");
    try { await api.post("/warehouses", f); onSaved(); }
    catch (e) { setErr(e?.response?.data?.detail || "Save failed"); }
    finally { setSaving(false); }
  };
  return (
    <Modal title="New warehouse" onClose={onClose} testid="warehouse-modal">
      <form onSubmit={save} className="space-y-4" data-testid="warehouse-form">
        <Field label="Code" required value={f.code} onChange={(v) => setF({ ...f, code: v })} testid="warehouse-code" />
        <Field label="Name" required value={f.name} onChange={(v) => setF({ ...f, name: v })} testid="warehouse-name" />
        <Field label="Location" value={f.location} onChange={(v) => setF({ ...f, location: v })} testid="warehouse-location" />
        {err && <div className="text-sm text-[#D90429]">{err}</div>}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onClose} className="px-4 py-2 text-sm border border-[#DEE2E6]">Cancel</button>
          <button type="submit" disabled={saving} data-testid="warehouse-save"
            className="px-4 py-2 text-sm bg-[#0A0A0A] hover:bg-[#FF4F00] text-white">Save</button>
        </div>
      </form>
    </Modal>
  );
}
